import "./App.css";
import MayaTool from "./mayaTool/MayaTool";

function App() {
  return <MayaTool showGulf={false} />;
}

export default App;
